import { render } from "./your-profile-factory-component.vue?vue&type=template&id=37e7ddae"
import script from "./your-profile-factory-component.vue?vue&type=script&lang=js"
export * from "./your-profile-factory-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__